<template>
  <div class="col-12 col-md-6 col-lg-3 d-flex">
    <div class="card card-cuadrada h-100 shadow-sm border-2 p-4 rounded-4 w-100">
      <div class="d-flex justify-content-between align-items-center">
        <i class="bi bi-filetype-xls text-success display-6"></i>
        <div class="d-flex gap-2 align-items-center">
          <!-- Botón de Descarga -->
          <button class="btn btn-success border border-1"
                  :disabled="isLoading || (requireParams && !readyToDownload)"
                  @click="manejadorDescarga">
            <i class="bi bi-download" v-if="requireParams"></i>
            <i class="bi bi-filetype-xls" v-else></i>
          </button>

          <!-- Estado / Texto -->
          <button v-if="!isLoading" class="btn btn-light border-0 ps-0">
            {{ statusText || '' }}
          </button>
          <b v-else class="text-muted small">Cargando...</b>

          <!-- Botón de Recargar -->
          <button class="btn btn-light border border-1 text-primary"
                  @click="obtenerReporte">
            <i class="bi bi-arrow-clockwise"></i>
          </button>
        </div>
      </div>
      <h5 class="mt-4 mb-2 card-title">{{ titulo }}</h5>
      <p class="mb-0 text-muted">{{ descripcion }}</p>

      <!-- Slot para filtros (Año, Mes, etc.) -->
      <div class="mt-3" v-if="$slots.filters">
        <slot name="filters"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardReporte",
  props: {
    titulo: String,
    descripcion: String,
    endpoint: String,
    fileName: String,
    statusText: String,
    requireParams: { type: Boolean, default: false },
    extraParams: { type: Object, default: () => ({}) },
    autoLoad: { type: Boolean, default: true }
  },
  data() {
    return {
      isLoading: false,
      blob: null
    };
  },
  computed: {
    readyToDownload() {
      // Si requiere parámetros, verificamos que no estén en "0" o vacíos
      if (!this.requireParams) return !!this.blob;
      return Object.values(this.extraParams).every(v => v !== "0" && v !== "");
    }
  },
  mounted() {
    if (this.autoLoad && !this.requireParams) {
      this.obtenerReporte();
    }
  },
  methods: {
    obtenerReporte() {
      this.isLoading = true;
      this.blob = null; // Limpiar previo
      this.axios
        .get(this.endpoint, { 
          params: this.extraParams,
          responseType: "blob" 
        })
        .then((response) => {
          this.blob = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(`Error al cargar reporte ${this.titulo}:`, error);
          this.isLoading = false;
        });
    },
    manejadorDescarga() {
      // Si el reporte requiere parámetros (como año/mes), descargamos al momento del clic
      if (this.requireParams) {
        this.descargarConFiltros();
      } else {
        this.descargarExcel();
      }
    },
    descargarExcel() {
      if (!this.blob) return;
      
      const url = window.URL.createObjectURL(new Blob([this.blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Opcional: Liberar memoria del objeto URL
      window.URL.revokeObjectURL(url);
    },
    descargarConFiltros() {
      this.isLoading = true;
      this.axios.get(this.endpoint, {
        params: this.extraParams,
        responseType: "blob"
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = this.fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error("Error al descargar reporte filtrado:", error);
      })
      .finally(() => this.isLoading = false);
    }
  }
};
</script>

<style scoped>
.card-cuadrada {
  min-height: 200px;
  transition: transform 0.2s;
}
.card-cuadrada:hover {
  transform: translateY(-5px);
}
</style>